import { render, staticRenderFns } from "./duo_workflow_action.vue?vue&type=template&id=c3933764"
import script from "./duo_workflow_action.vue?vue&type=script&lang=js"
export * from "./duo_workflow_action.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports